import { AutoAwesomeRounded } from '@mui/icons-material';
import UndoIcon from '@mui/icons-material/Undo';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import gtmIds from 'services/tracking/GTMIds';
import { withGtmInteraction } from 'services/tracking/withGtmInteraction';
import styled from 'styled-components';
import { withTestId } from 'utils/utils';

export const IMPROVE_PROMPT_OUTPUT_TYPE = 'improve_prompt';

type Props = {
  prompt: string;
  loading: boolean;
  undoVisible: boolean;

  onOptimizeClick: () => void;
  onUndoClick: () => void;
  onMouseDown?: (e: MouseEvent) => void;
};

export function ChatOptimizePromptButton(props: Props) {
  const { prompt, loading, undoVisible, onOptimizeClick, onUndoClick, onMouseDown } = props;

  const isTooLong = prompt.length > 20000;
  const isTooShort = prompt.length === 0;

  const tooltipText = isTooLong
    ? 'aiWriter.inspirations.chat.message.optimize.tooltip.disabled'
    : 'aiWriter.inspirations.chat.message.optimize.tooltip';

  const isDisabled = isTooLong || isTooShort;

  if (undoVisible) {
    return (
      <IconButton
        {...withGtmInteraction(gtmIds.aiWriter.chat.undoOptimizePrompt)}
        {...withTestId('optimize-button')}
        onClick={onUndoClick}
      >
        <UndoIcon />
      </IconButton>
    );
  }

  return (
    <Tooltip title={<FormattedMessage id={tooltipText} />}>
      <span>
        <IconButton
          onClick={onOptimizeClick}
          disabled={isDisabled}
          {...withGtmInteraction(gtmIds.aiWriter.chat.optimizePrompt)}
          onMouseDown={onMouseDown}
        >
          {loading ? <CircularProgress size={20} /> : <OptimizeIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
const OptimizeIcon = styled(AutoAwesomeRounded)``;
